import React from "react";

const VerticalTimeline = ({ config } = props) => {
	const removeHTMLTags = data => data.replace(/<\/?[^>]+(>|$)/g, " ");
	
	return (
		<div className="vertical-timeline">
			{config.data.map((item, index) => (
				<div key={index} className={`vertical-timeline__item ${config.lengthMax ? "default" : item.active ? config.activeColor : "default"}`}>
					<div className="vertical-timeline__item--marker-title">
						<div
							className={`vertical-timeline__item--marker-title--marker vertical-timeline__item--marker-title--marker--${
								index === 5 ? config.inactiveColor : config.lengthMax ? config.activeColor : !!item && item.active ? config.activeColor : !!item && item.active === false ? config.inactiveColor : "default"
							}`}
						>
							<i
								className={`icon-${
									index === 5 ? config.inactiveIcon : config.lengthMax || item.active ? config.activeIcon : item.active === false && config.inactiveIcon
								}`}
							/>
						</div>
						<div className="vertical-timeline__item--marker-title--title">
							{removeHTMLTags(item.label)}
						</div>
					</div>
					{item.description && removeHTMLTags(item.description)}
				</div>
			))}
		</div>
	);
};

export default VerticalTimeline;
